import { render } from "./ProcessMemoryDisplay.vue?vue&type=template&id=3cbb9c98"
import script from "./ProcessMemoryDisplay.vue?vue&type=script&lang=js"
export * from "./ProcessMemoryDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__